export const container = {
  minWidth: '1080px',
  maxWidth: '1440px',
};
